import { AttachmentData, AttachmentUpload } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';
import { AxiosHeaders } from 'axios';

import { Headers, HttpClient } from '../utils';

export const uploadAttachment = async (
  file: File | { name: string; type: string; uri: string },
  channelId: string,
  roomId: string,
  clientMessageId: string,
) => {
  const formData = new FormData();

  formData.append('file', file as File);

  const headers = new AxiosHeaders().set({
    'Content-Type': 'multipart/form-data',
  }) as Headers;

  return HttpClient.post<AttachmentUpload>(
    API_FACTORY.v2(`rooms/${roomId}/channels/${channelId}/messages/${clientMessageId}/attachments`),
    formData,
    headers,
  );
};

export const getAttachmentUrl = (
  attachment: Pick<AttachmentData, 'channelId' | 'externalId' | 'id' | 'clientMessageId' | 'roomId'>,
): string =>
  API_FACTORY.v2(
    `rooms/${attachment.roomId}/channels/${attachment.channelId}/messages/${attachment.clientMessageId}/attachments/${attachment.externalId ?? attachment.id}`,
  );

export const getAttachmentById = (
  attachment: Pick<AttachmentData, 'channelId' | 'externalId' | 'id' | 'clientMessageId' | 'roomId'>,
) => HttpClient.get<Blob>(getAttachmentUrl(attachment), undefined, undefined, 'blob');
